import { render, staticRenderFns } from "./designRepetitionPromptModal.vue?vue&type=template&id=4ac4774c"
import script from "./designRepetitionPromptModal.vue?vue&type=script&lang=js"
export * from "./designRepetitionPromptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports